import { EnrollFreeResourceRequestDto } from '../../helper-types/dtos/enrollment/requests/enroll-free-resource-request-dto';
import { GetPaginatedEnrollmentRequestRequestDto } from '../../helper-types/dtos/enrollment/requests/get-paginated-enrollment-request-request-dto';
import { RequestEnrollmentRequestDto } from '../../helper-types/dtos/enrollment/requests/request-enrollment-request-dto';
import { RespondToEnrollmentRequestRequestDto } from '../../helper-types/dtos/enrollment/requests/respond-to-enrollment-request-request-dto';
import { GetPaginatedEnrollmentRequestResponseDto } from '../../helper-types/dtos/enrollment/responses/get-paginated-enrollment-request-response-dto';
import { GetTenantPaymentChannelsResponseDto } from '../../helper-types/dtos/tenant-settings/responses/get-tenant-payment-channels-response-dto';
import { API_RELATIVE_URI } from '../../helper-types/general/consts/api-relative-uri';
import { ApiResponse } from '../../helper-types/general/custom-types/api-response';
import { PaginatedList } from '../../helper-types/general/custom-types/paginated-list';
import HTTP_CLIENT from '../common/http-client-wrapper';

export class EnrollmentService {
    private readonly _httpClient: typeof HTTP_CLIENT;

    constructor(httpClient: typeof HTTP_CLIENT) {
        this._httpClient = httpClient;
    }

    async getPaymentChannelsAsync(): Promise<ApiResponse<GetTenantPaymentChannelsResponseDto>> {
        return await this._httpClient.getFromJsonAsync<ApiResponse<GetTenantPaymentChannelsResponseDto>>(
            API_RELATIVE_URI.ENROLLMENT_PAYMENT_CHANNELS
        );
    }

    async requestEnrollmentAsync(dto: RequestEnrollmentRequestDto): Promise<ApiResponse<object>> {
        return await this._httpClient.postAsJsonAsync<
            RequestEnrollmentRequestDto,
            ApiResponse<object>
        >(API_RELATIVE_URI.REQUEST_ENROLLMENT, dto);
    }

    async cancelEnrollmentRequestAsync(requestId: number): Promise<ApiResponse<object>> {
        return await this._httpClient.postAsJsonAsync<null, ApiResponse<object>>(
            `${API_RELATIVE_URI.CANCEL_ENROLLMENT_REQUEST}?requestId=${requestId}`,
            null
        );
    }

    async enrollFreeResourceAsync(dto: EnrollFreeResourceRequestDto): Promise<ApiResponse<object>> {
        return await this._httpClient.postAsJsonAsync<
            EnrollFreeResourceRequestDto,
            ApiResponse<object>
        >(API_RELATIVE_URI.ENROLL_FREE_RESOURCE, dto);
    }

    async cancelEnrollmentAsync(enrollmentId: number): Promise<ApiResponse<object>> {
        return await this._httpClient.postAsJsonAsync<null, ApiResponse<object>>(
            `${API_RELATIVE_URI.CANCEL_ENROLLMENT}?enrollmentId=${enrollmentId}`,
            null
        );
    }

    // Instructor methods

    async getPaginatedEnrollmentRequestsAsync(dto: GetPaginatedEnrollmentRequestRequestDto): Promise<ApiResponse<PaginatedList<GetPaginatedEnrollmentRequestResponseDto>>> {
        return await this._httpClient.postAsJsonAsync<
            GetPaginatedEnrollmentRequestRequestDto,
            ApiResponse<PaginatedList<GetPaginatedEnrollmentRequestResponseDto>>
        >(API_RELATIVE_URI.PAGINATED_ENROLLMENT_REQUESTS, dto);
    }

    async getPendingEnrollmentRequestsCountAsync(): Promise<ApiResponse<number>> {
        return await this._httpClient.getFromJsonAsync<ApiResponse<number>>(
            API_RELATIVE_URI.PENDING_ENROLLMENT_REQUESTS_COUNT
        );
    }

    async respondToEnrollmentRequestAsync(dto: RespondToEnrollmentRequestRequestDto): Promise<ApiResponse<object>> {
        return await this._httpClient.postAsJsonAsync<
            RespondToEnrollmentRequestRequestDto,
            ApiResponse<object>
        >(API_RELATIVE_URI.RESPOND_TO_ENROLLMENT_REQUEST, dto);
    }
}

// Export a singleton instance
export const ENROLLMENT_SERVICE = new EnrollmentService(HTTP_CLIENT);
